function ready(callback: () => void) {
  if (document.readyState !== "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

const HEADER_OPEN_CLASS = "show-menu";
const BODY_OPEN_CLASS = "nav-menu-open";
const MOBILE_QUERY = "(max-width: 1100px)";

function applyMenu() {
  const header = document.querySelector<HTMLElement>("header.site-header");
  if (!header) return;

  const toggle = header.querySelector<HTMLButtonElement>(".menu-toggle");
  const close = header.querySelector<HTMLButtonElement>(".menu-close");
  if (!toggle) return;

  let isOpen = false;

  const setState = (next: boolean) => {
    isOpen = next;
    header.classList.toggle(HEADER_OPEN_CLASS, next);
    document.body.classList.toggle(BODY_OPEN_CLASS, next);
    toggle.setAttribute("aria-expanded", next ? "true" : "false");

    if (next) {
      close?.focus();
    } else {
      toggle.focus();
    }
  };

  toggle.addEventListener("click", (evt) => {
    evt.preventDefault();
    setState(!isOpen);
  });

  close?.addEventListener("click", (evt) => {
    evt.preventDefault();
    setState(false);
  });

  document.addEventListener("keydown", (evt: KeyboardEvent) => {
    if (isOpen && evt.key === "Escape") {
      setState(false);
    }
  });

  const mql = window.matchMedia(MOBILE_QUERY);
  const handleMediaChange = (event: MediaQueryListEvent) => {
    if (!event.matches && isOpen) {
      setState(false);
    }
  };

  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", handleMediaChange);
  } else {
    mql.addListener(handleMediaChange);
  }
}

export default function siteMenu() {
  ready(applyMenu);
}
